export const PHONE_DISPLAY = "242-809-6853";
export const PHONE_SHORT = "809-6853";
export const PHONE_TEL = "tel:+12428096853";
export const WHATSAPP_URL = "https://wa.me/12428096853";
export const COMPANY = "SMS Electrical & Fiber Optic Installers";
export const TAGLINE = "POWERING TODAY. CONNECTING TOMORROW.";
export const SERVICE_LINE =
  "Three-Phase Electrical • Residential • Commercial • Industrial • Fiber Optics";

export const CONTACTS = [
  { label: "242-809-6853", tel: "tel:+12428096853", whatsapp: true },
  { label: "242-602-4147", tel: "tel:+12426024147", whatsapp: false },
  { label: "754-313-0555", tel: "tel:+17543130555", whatsapp: false },
];

export const WEBSITE = { label: "www.smselectrical.com", url: "https://www.smselectrical.com" };

export const FLYER_SERVICES = [
  "Electrical Construction",
  "Electrical Repairs",
  "Lighting Systems",
  "Circuit Installation & Repairs",
  "Outdoor Lighting",
  "Panel Repair & Upgrade",
  "Receptacles & Ceiling Fans Installation",
  "Fiber Optic Testing & Repairs",
  "Fiber Optic Installation",
];

export const HOME_SERVICES = [
  {
    icon: "home",
    title: "Residential",
    text: "Electrical installations, repairs and upgrades.",
  },
  {
    icon: "building",
    title: "Commercial",
    text: "Electrical solutions for businesses.",
  },
  {
    icon: "gear",
    title: "Industrial (3 Phase)",
    text: "Installation, maintenance and troubleshooting.",
  },
  {
    icon: "cable",
    title: "Fiber Optic Installations",
    text: "Structured cabling, splicing and network setup.",
  },
];

export const GALLERY = [
  {
    src: "/assets/work-splicing.jpg",
    alt: "Technician performing fiber optic splicing",
    cat: "Fiber Optics",
  },
  {
    src: "/assets/photo-fiber-cabinet.webp",
    alt: "Fiber optic cabinet with orange fiber cabling",
    cat: "Fiber Optics",
  },
  {
    src: "/assets/photo-fusion-splicer.webp",
    alt: "Optical fiber fusion splicer on site",
    cat: "Fiber Optics",
  },
  {
    src: "/assets/photo-pumps.webp",
    alt: "Three-phase industrial pump control installation",
    cat: "Three-Phase Electrical",
  },
  {
    src: "/assets/photo-abb-controls.webp",
    alt: "ABB three-phase contactor and control wiring",
    cat: "Industrial Systems",
  },
];
